import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";
import { IFillDataWizardBuy } from "../../..";
import Button from "../../../../../../../ui/button";
import useDealRequest from "../../../../../../../../api/hooks/use-deal-request";
import { getAccessToken } from "../../../../../../../../lib/services/localStorage.service";
import {
  EDealRequestType,
  EMarketTypes,
} from "../../../../../../../../interfaces";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AuthModal from "../../../../../../auth/components/modals/authModal";
import { PATHS } from "../../../../../../../shared/constants";
import useOpenModal from "../../../../../../../ui/modal/hooks/useOpenModal";

interface IWishStepBuy_5 {
  data: IFillDataWizardBuy;
}

const WishStepBuy_5 = ({ data }: IWishStepBuy_5) => {
  const { goToStep } = useWizard();
  const navigate = useNavigate();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.buy.step_4);
  };

  const {
    data: dataDealRequest,
    error,
    isMutating,
    trigger,
  } = useDealRequest();

  
  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({
          type: EDealRequestType.Purchase,
          data,
          marketType: EMarketTypes.SECONDARY,
        });
        toast.success("Заявка на покупку создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      <BaseStep prevStep={handlePrevStep} text="Отправка заявки:">
        <div>
          <Button
            label="Отправить заявку на покупку"
            onClick={handleSendData}
          />
          <AuthModal
            opened={openAuth}
            onClose={() => handleChangeModalAuth(false)}
            offsetY={offsetYAuth}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default WishStepBuy_5;
